import { render, staticRenderFns } from "./ServiceAreaTable.vue?vue&type=template&id=1aff765c&scoped=true"
import script from "./ServiceAreaTable.vue?vue&type=script&lang=js"
export * from "./ServiceAreaTable.vue?vue&type=script&lang=js"
import style0 from "./ServiceAreaTable.vue?vue&type=style&index=0&id=1aff765c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aff765c",
  null
  
)

export default component.exports